const dateOnly = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
};

// Las copias históricas conservan camiones trasladados. No son pendientes
// del día de origen, pero tampoco se deben marcar como finalizados ni borrar.
export function getOperationDayState(operation, day, truckState) {
  const trucks = Array.isArray(operation?.camiones) ? operation.camiones : [];
  if (!operation || operation.soloComentario || operation.esComentario ||
      (operation.cantidadCamiones === 0 && !trucks.length)) {
    return { trucks: [], hasPending: false };
  }
  const currentDay = dateOnly(day);
  const declaredCount = Number(operation.cantidadCamiones);
  const count = Math.max(1, Number.isFinite(declaredCount) ? declaredCount : 0, trucks.length);
  const hasTruckTransferDates = trucks.some((truck) => dateOnly(truck.pospuestoA));
  const legacyDestination = dateOnly(operation.pospuestoA) || dateOnly(operation.pasarMananaDia);
  const states = Array.from({ length: count }, (_, index) => {
    const truck = trucks.find((item, position) => Number(item.index ?? position) === index) || {};
    const finalized = !!dateOnly(truck.fechaFinalizado) || truckState(truck.dibujo || operation.dibujo || "") === "finalizado";
    const destination = dateOnly(truck.pospuestoA);
    let transferredTo = currentDay && destination > currentDay ? destination : "";
    // Compatibilidad con versiones que guardaban el traslado solo en la
    // operativa. Si hay fechas individuales, no se extiende a otros camiones.
    if (!transferredTo && !hasTruckTransferDates && !finalized && currentDay && legacyDestination > currentDay) {
      transferredTo = legacyDestination;
    }
    return { index, finalized, transferredTo, pendingHere: !finalized && !transferredTo };
  });
  return { trucks: states, hasPending: states.some((truck) => truck.pendingHere) };
}
